import TextField from '@sdk/components/forms/TextField';
import Text12 from '@sdk/components/ui/typography/Text12';
import gettext from '@sdk/lang/gettext';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import validateEmail from '@sdk/utils/validation/validateEmail';

import { BillingFieldLabel } from '@web/account/billing/BillingFieldLabel';

import AddGraySvg from '../../../assets/svg/UI/add-gray.svg';

import { AddEmail } from './billingEmails.styles';

type Props = {
  emails: string[];
  setEmails: (emails: string[]) => void;
  showValidationErrors: boolean;
};

const BillingEmails = ({ emails, setEmails, showValidationErrors }: Props) => {
  return (
    <div>
      <BillingFieldLabel>{gettext('billing email')}</BillingFieldLabel>
      {emails.map((email, index) => (
        <Row mTop={index ? 5 : 0} key={index}>
          <TextField
            value={email}
            onChange={({ target: { value } }): void => {
              const updated = [...emails];
              updated[index] = value;
              setEmails(updated);
            }}
            skipErrorMessage
            placeholder={gettext('example@email.com')}
            invalid={showValidationErrors && email && !validateEmail(email)}
          />
        </Row>
      ))}
      <AddEmail
        alignItems="center"
        mTop={6}
        mLeft={-4}
        onClick={(): void => setEmails([...emails, ''])}>
        <Row mRight={5}>
          <AddGraySvg />
        </Row>
        <Text12 semiBold themeColor={ThemeColorType.gray}>
          {gettext('Add another email')}
        </Text12>
      </AddEmail>
    </div>
  );
};

export default BillingEmails;
